export default __webpack_public_path__ + "static/media/pasta-arquivos-imagem.fbc9c277.svg";